
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionValuesDialog extends Serenity.EntityDialog<QualityInspectionValuesRow, any> {
        protected getFormKey() { return QualityInspectionValuesForm.formKey; }
        protected getIdProperty() { return QualityInspectionValuesRow.idProperty; }
        protected getLocalTextPrefix() { return QualityInspectionValuesRow.localTextPrefix; }
        protected getNameProperty() { return QualityInspectionValuesRow.nameProperty; }
        protected getService() { return QualityInspectionValuesService.baseUrl; }
        protected getDeletePermission() { return QualityInspectionValuesRow.deletePermission; }
        protected getInsertPermission() { return QualityInspectionValuesRow.insertPermission; }
        protected getUpdatePermission() { return QualityInspectionValuesRow.updatePermission; }

        protected form = new QualityInspectionValuesForm(this.idPrefix);

    }
}